import {API_HOST, API_SUBDOMAIN, FRONT_ENV, LOCAL_API_URL} from '@env';

import {findFrontMobileEnvironment} from '../../libs/shared/helpers/src/environment/envConfig';
import {isDevelopment} from '../../libs/shared/helpers/src/environment/envHelpers';
import {isMobile} from '../../libs/shared/helpers/src/environment/mobileEnvHelpers';
import {FrontConfigGlobals} from './bundlerConfigTypes';

// @env module is only used locally and ignored by the CI
// Production builds made with EAS use environment variables defined in deploy.ts
export const FrontMobileConfig = buildFrontMobileConfig();

function buildFrontMobileConfig(): FrontConfigGlobals {
  const frontEnvRaw = process.env.FRONT_ENV ?? FRONT_ENV;
  const frontEnv = findFrontMobileEnvironment(frontEnvRaw);

  return {
    BASE_URL: '',
    ...findApiConfig(),
    MAIN_APP_INTEROP_URL: '',
    APPLICATION_RUNTIME_HOST: '',
    APPLICATION_RUNTIME_ENGINE_PATH: '',
    APPLICATION_RUNTIME_VIEW_PATH: '',
    GIT_COMMIT: findGitCommit(),
    BUILD_TIMESTAMP: '',
    DUMP_TRACKING_EVENTS_TO_CONSOLE: false,
    FRONT_ENV: frontEnv,
    STAGING_NAMESPACE: '',
  };
}

function findGitCommit() {
  if (process.env.EAS_BUILD_GIT_COMMIT_HASH) {
    return process.env.EAS_BUILD_GIT_COMMIT_HASH;
  }

  if (process.env.GIT_COMMIT_HASH) {
    return process.env.GIT_COMMIT_HASH;
  }

  if (isDevelopment() || !isMobile()) {
    return '';
  }

  throw new Error('Missing Git commit hash');
}

function findApiConfig() {
  // Local environment
  if (process.env.LOCAL_API_URL || process.env.APP_ENV === 'localhost') {
    const localApiUrl = process.env.LOCAL_API_URL || LOCAL_API_URL;
    if (!localApiUrl) {
      throw new Error('Missing LOCAL_API_URL');
    }

    return {
      API_URL: localApiUrl,
      API_SUBDOMAIN: '',
    };
  }

  // Staging, preprod, prod
  const subdomain = process.env.API_SUBDOMAIN ?? API_SUBDOMAIN;
  const host = process.env.API_HOST ?? API_HOST;
  if (!subdomain) {
    throw new Error('Missing API_SUBDOMAIN');
  }
  if (!host) {
    throw new Error('Missing API_HOST');
  }

  return {
    API_URL: `https://${subdomain}.${host}`,
    API_SUBDOMAIN: subdomain,
  };
}
